<div
	#optionBoard
	class="option-board-table"
>
	<app-table
		[statesColumns]="statesColumns()"
		[settings]="{
			size: 'md',
			spreadContent: 'space-between',
			rowBorder: true,
			emptyTextPath: 'options.empty',
		}"
		[items]="options()"
		[isLoading]="isLoadingOptions()"
		[isLoadingTop]="isLoadingTop()"
		[isLoadingBottom]="isLoadingBottom()"
		[scrollToPosition]="dynamicPriceRowPositionPx()"
		[isPoolScroll]="isPoolScrollTrigger()"
		(onReachTop)="sendReqOptionsByNextUrl(directionEnum.TOP)"
		(onReachBottom)="sendReqOptionsByNextUrl(directionEnum.BOTTOM)"
	>
		<app-table-column
			[settings]="{
				titlePath: 'options.columns.strike',
				column: optionsBoardColumnsEnum.strike,
			}"
		>
			<ng-template let-item="item">
				<span class="text">
					{{ item.details.strike_price | price }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.bid',
				column: optionsBoardColumnsEnum.bid,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isPositive]="true"
					[isNeutral]="!item.last_quote.bid"
				>
					{{ item.last_quote.bid | price }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.ask',
				column: optionsBoardColumnsEnum.ask,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isNegative]="true"
					[isNeutral]="!item.last_quote.ask"
				>
					{{ item.last_quote.ask | price }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.last',
				column: optionsBoardColumnsEnum.last,
				spreadContent: 'flex-end',
				minWidthPx: 80,
			}"
		>
			<ng-template let-item="item">
				<span class="text">
					{{ item.last_trade.price ?? '-' | price }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.change',
				column: optionsBoardColumnsEnum.change,
				spreadContent: 'flex-end',
				minWidthPx: 80,
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isNegative]="(item?.day?.change_percent ?? 0) < 0"
					[isPositive]="(item?.day?.change_percent ?? 0) > 0"
					[isNeutral]="!item?.day?.change_percent"
				>
					{{ item?.day?.change_percent | profit: 'percent' }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.breakeven',
				column: optionsBoardColumnsEnum.breakeven,
				minWidthPx: 80,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span class="text">
					{{ item.break_even_price ?? '-' | price }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.volatility',
				column: optionsBoardColumnsEnum.volatility,
				minWidthPx: 80,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span class="text">
					{{ item.implied_volatility | price: false }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.interest',
				column: optionsBoardColumnsEnum.interest,
				spreadContent: 'flex-end',
				minWidthPx: 80,
			}"
		>
			<ng-template let-item="item">
				<span class="text">
					{{ item.open_interest | quantity }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.delta',
				column: optionsBoardColumnsEnum.delta,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isNeutral]="!item.greeks.delta"
				>
					{{ item.greeks.delta | price: false }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.gamma',
				column: optionsBoardColumnsEnum.gamma,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isNeutral]="!item.greeks.gamma"
				>
					{{ item.greeks.gamma | price: false }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.theta',
				column: optionsBoardColumnsEnum.theta,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isNeutral]="!item.greeks.theta"
				>
					{{ item.greeks.theta | price: false }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'options.columns.vega',
				column: optionsBoardColumnsEnum.vega,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isNeutral]="!item.greeks.vega"
				>
					{{ item.greeks.vega | price: false }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-actions>
			<ng-template let-item="item">
				<app-options-board-table-actions [option]="item" />
			</ng-template>
		</app-table-actions>

		@if (dynamicPriceRowSettings()) {
			<app-table-dynamic-row [rowSettings]="dynamicPriceRowSettings()">
				<ng-template>
					@if (dynamicPriceRowPositionPx() > 0) {
						<div
							#dynamicPriceRow
							class="dynamic-row-price"
						>
							<div class="wrapper">
								<span class="text">{{ 'options.stockPrice' | translate }}</span>
								<span
									class="value"
									[appAnimatedNumber]="liveTicker()?.currentPrices?.price | price"
								></span>
							</div>
						</div>
					}
				</ng-template>
			</app-table-dynamic-row>
		}
	</app-table>
</div>
